var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicesBannerMobile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 371,
    viewBox: "0 0 375 371",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18314 272.177C-78.7689 203.213 -82.2169 125.405 -57.8709 79.299C-33.5249 33.193 41.8331 34.385 112.539 70.808C145.787 87.937 195.331 63.167 244.77 38.396C300.46 10.496 356.019 -17.404 388.004 14.578C448.383 74.961 378.59 149.195 364.714 214.478C351.353 277.335 413.967 337.333 335.673 363.445C320.959 368.352 303.051 370.627 283.141 370.629C197.099 370.634 73.3581 328.185 5.18314 272.177Z",
    fill: "#72BEB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-68.7959 140.665C-68.7959 140.665 112.152 139.096 159.069 112.028C205.986 84.96 257.196 29.6561 311.264 31.9831C365.332 34.3101 383.551 76.194 377.087 112.028C370.623 147.862 330.587 172.17 279.787 192.218C228.987 212.266 104.005 197.249 104.005 197.249C104.005 197.249 25.7321 189.764 14.3491 214.858C2.96612 239.952 6.83614 266.999 61.2961 292.595C115.756 318.191 252.961 283.618 252.961 283.618C252.961 283.618 287.952 257.703 377.086 245.836",
    stroke: "#EAE7DE",
    strokeWidth: 3,
    strokeDasharray: "15 10"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBannerMobile);
export default __webpack_public_path__ + "static/media/servicesBannerMobile.d107dc8bde489f412c555c36e62a5230.svg";
export { ForwardRef as ReactComponent };